export const convertBytesToMo = (bytes, decimals = 2) => {
  const ONE_KILOBYTE = 1024;

  if (!+bytes) return 0;
  const megabytes = bytes / (ONE_KILOBYTE * ONE_KILOBYTE);
  return megabytes.toFixed(decimals);
};
